<template>
  <div>
    <Title title="团队管理"></Title>

    <div class="manager">
      <div class="item" v-for="(item, index) in list" :key="item.id">
        <img :src="item.extends.face" class="img" alt="" @click="current = index">
      </div>
    </div>

    <template v-if="list.length">
      <h1 class="name">
        {{ list[current].title }}
      </h1>
      <h2 class="sub-title">{{ list[current].subTitle }}</h2>
      <p class="desc">
        {{ list[current].desc }}
      </p>
      <img :src="list[current].resource" alt="" class="background-img" :class="`background-img${current}`">
    </template>


  </div>
</template>

<script>
// import manager from '../../../../../../public/manager.json'
import Title from '@/components/mobile/Title'
export default {
  components: {
    Title
  },
  data() {
    return {
      list: [],
      current: 0,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      const [err, res] = await this.$http.get('manager')
      if (err) return
      this.list = res.list
    }
  }
}
</script>

<style scoped lang="less">
.manager {
  margin-top: 1.8rem;
  white-space: nowrap;
  overflow: scroll;
  margin-bottom: .6667rem;

  .item {
    display: inline-block;
    width: 1.88rem;
    height: 1.88rem;

    margin-right: .92rem;

    .img {
      width: 100%;
      height: 100%;
      // border-radius: 1.3333rem;
      object-fit: contain;
    }
  }
}

.name {
  font-size: .5333rem;
  margin-bottom: .1333rem;
  font-weight: bold;
}

.sub-title {
  font-size: .3733rem;
  position: relative;
  margin-bottom: 1.0667rem;

  &::after {
    content: "";
    width: .5733rem;
    height: .12rem;
    background: #F7931E;
    border-radius: .0667rem;
    position: absolute;
    left: 0;
    bottom: -0.2667rem;
  }
}

.desc {
  color: #666;
  font-size: .32rem;
  line-height: .6667rem;
  width: 4.4667rem;
  position: relative;
  z-index: 99;
}

.background-img {
  width: 6.0267rem;
  height: 8.9867rem;
  object-fit: contain;
  position: absolute;
  right: -0.6667rem;
  bottom: -0.3667rem;
}

.background-img2 {
  width: 5.2133rem;
  // height: 9.48rem;
  bottom: -0.3667rem;
}
</style>